import { isPending, Middleware } from '@reduxjs/toolkit';
import { noteRequestStarted } from 'shared/utils/request-tracker';

/**
 * Считает стартовавшие thunk-и для dev-детектора «потерянного промиса» (`shared/utils/request-tracker.ts`).
 * RTK 1.9 диспатчит `pending` синхронно в момент `dispatch(thunk)`, поэтому счётчик успевает вырасти
 * внутри вызова обработчика кнопки.
 */
export const requestTrackerMiddleware: Middleware = () => (next) => (action) => {
  if (isPending(action)) noteRequestStarted();
  return next(action);
};
